import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { CommonModule } from '@angular/common';
import { EYesNo } from '../../../../../shared/models/types.enum';

@Component({
  selector: 'situation-review',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './situation-review.component.html',
  styleUrl: './situation-review.component.css'
})
export class SituationReviewComponent implements OnInit, OnChanges {

  @Input() studentInterviewData: any = null;
  @Output() onSaveSection2 = new EventEmitter<any>();

  yesNo = EYesNo;

  situationReviewForm: FormGroup = new FormGroup([]);
  questionList = [
    {
      question: "Do you know why I wanted to talk with you? *",
      formControlName: "reason_for_talking",
    },
    {
      question: "Explain what happened, including where and when. *",
      formControlName: "what_happened",
    },
    {
      question: "Who else was present when this occurred? *",
      formControlName: "other_presense",
    },
    {
      question: "What exactly did you do? (Write down the student's exact words.) *",
      formControlName: "student_word_actions",
    },
    {
      question: "What exactly did you say? (Write down the student's exact words.) *",
      formControlName: "student_words",
    },
    {
      question: "What did you mean when you said or did that? *",
      formControlName: "student_meaning",
    }
  ]

  radioQuestions = [
    {
      id: 'access_weapon',
      questionText: "Do you have access to weapons or dangerous items? *",
      formControlName: 'access_weapon',
      infoFormControlName: 'access_weapon_information'
    }
  ];

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['studentInterviewData'] && this.studentInterviewData) {
      this.initializeForm();
    }
  }

  private initializeForm(): void {
    const group: any = {};
    
    this.radioQuestions.forEach(question => {
      const defaultValue = this.studentInterviewData && this.studentInterviewData[question.formControlName] !== undefined
                           ? this.studentInterviewData[question.formControlName]
                           : this.yesNo.No;

      group[question.formControlName] = new FormControl(
          String(defaultValue),
          Validators.required
      );
      group[question.infoFormControlName] = new FormControl({ value: this.studentInterviewData?.[question.infoFormControlName] || '', disabled: this.studentInterviewData?.[question.infoFormControlName] ? false : true });
    });
    this.questionList.forEach(question => {
      group[question.formControlName] = new FormControl(this.studentInterviewData?.[question.formControlName] || '', Validators.required);
    });

    this.situationReviewForm = new FormGroup(group);
    this.setupFormChangeHandlers();
  }

  private setupFormChangeHandlers() {
    const conditions = [
      {key: 'access_weapon', infoKey: 'access_weapon_information'}
    ];
    conditions.forEach(condition => {
      this.situationReviewForm.get(condition.key)!.valueChanges.subscribe(val => {
        const control = this.situationReviewForm.get(condition.infoKey);
        if (control) {
          this.formUtils.handleConditionChange(control, val === '1');
        }
      });
    });
  }

  saveSituationReview(): void {
    if (this.situationReviewForm.valid) {
      this.onSaveSection2.emit(this.situationReviewForm.value);
    }
  }

}
